export default "__VITE_ASSET__Dqnc_6pv__"